<template>
  <div class="subusers">
    <div class="card">
      <h2>Operador</h2>
      <SubuserForm
        user-type="operator"
      />
    </div>
    <div class="card">
      <h2>Reportero</h2>
      <SubuserForm
        user-type="reporter"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SubuserForm from '@/components/Subusers/SubuserForm'

export default {
  name: 'Subusers',
  components: {
    SubuserForm
  },
  async beforeMount () {
    await this.getUsers()
  },
  computed: {
    ...mapGetters('subusers', [
      'operator',
      'reporter'
    ])
  },
  methods: {
    ...mapActions('subusers', [
      'getUsers'
    ])
  }
}
</script>

<style scoped lang="scss">
.subusers {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 2rem;
}

.card {
  background-color: white;
  border-radius: 1rem;
  flex: 0 1 40rem;
  margin: 1rem;
  padding: 1rem;
}
</style>
